import { useCallback } from 'react'
import { Box } from '@mui/material'
import { FullPageListSkeleton } from '$common/full-page-list-skeleton'
import { SearchedRoomListItemWithStatus } from './components/searched-room-list-item-with-status'
import { SearchedUserListItemWithStatus } from '$common/room-list-search/searched-user-list-item-with-status'
import { SearchedHallListItemWithStatus } from '$common/room-list-search/searched-hall-list-item-with-status'
import { SearchSection } from '$common/room-list-search/search-section'
import { useSearchedLocalRooms } from '$logic/room-list/room-list-search.react-hook'
import { t } from '$i18n'
import { addToRecentSearch } from '$logic/room-list/room-list-search.service'
import { openRoom } from '$logic/opened-room'

export function ForwardListSearched({
  query,
  onSelectedChange,
  onSelect,
  hasSelection,
  selectionMap,
}: {
  query: string
  hasSelection: boolean
  selectionMap: Record<string, boolean>
  onSelectedChange: (selected: boolean, chatId: string) => unknown
  onSelect: (selectedRoomId: string) => unknown
}) {
  const localSearch = useSearchedLocalRooms(query)
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const globalSearch = { loading: false, users: [], halls: [], contacts: [] }

  const globalResultCount =
    globalSearch.users.length +
    globalSearch.halls.length +
    globalSearch.contacts.length

  const onClick = useCallback(
    (roomId: string, selected: boolean) => {
      if (selected) onSelectedChange(false, roomId)
      else if (hasSelection) {
        onSelectedChange(true, roomId)
        addToRecentSearch({ type: 'ROOM', id: roomId })
      } else if (onSelect) onSelect(roomId)
      else openRoom(roomId)
    },
    [hasSelection, onSelectedChange],
  )

  const onContextMenu = useCallback(
    (e: Event, roomId: string) => {
      e.preventDefault()
      if (!hasSelection) {
        onSelectedChange(true, roomId)
        addToRecentSearch({ type: 'ROOM', id: roomId })
      }
    },
    [hasSelection, onSelectedChange],
  )

  const resultCount = localSearch.roomIds.length + globalResultCount

  if (resultCount === 0 && (globalSearch.loading || localSearch.loading))
    return <FullPageListSkeleton />

  return (
    <Box sx={{ height: '100%', overflow: 'auto' }}>
      {!!localSearch.roomIds.length && (
        <Box sx={{ padding: '5px 0', backgroundColor: 'white' }}>
          {localSearch.roomIds.map(roomId => (
            <SearchedRoomListItemWithStatus
              key={roomId}
              roomId={roomId}
              onClick={onClick}
              onContextMenu={onContextMenu}
              selectionMap={selectionMap}
            />
          ))}
        </Box>
      )}

      {globalResultCount > 0 && (
        <>
          <SearchSection primaryText={t('chatListSearch.globals')} />
          <Box sx={{ padding: '5px 0', backgroundColor: 'white' }}>
            {globalSearch.contacts.map(({ id }) => (
              <SearchedUserListItemWithStatus key={id} userId={id} />
            ))}
            {globalSearch.users.map(({ id }) => (
              <SearchedUserListItemWithStatus key={id} userId={id} />
            ))}
            {globalSearch.halls.map(({ roomId }) => (
              <SearchedHallListItemWithStatus
                key={roomId}
                roomId={roomId}
                searchQuery={query}
                onClick={() => {
                  /* openRoom(roomId) */
                  // addToRecentSearch({ type: 'ROOM', id: roomId })
                }}
              />
            ))}
          </Box>
        </>
      )}
    </Box>
  )
}
